module.exports = __webpack_public_path__ + "static/media/off.b868bf8b.png";